import priyaImage from "../../assets/National Academic.png";
import girishImage from "../../assets/Fundraising Committee1.png";
import bipinImage from "../../assets/Safety Committee.png";
import nileshImage from "../../assets/Innovation Committee.png";
import divyangImage from "../../assets/Visionary Leader.png";
import { useNavigate } from "react-router-dom";

export default function CommitteePage() {
  const navigate = useNavigate();
  const committeeMembers = [
    {
      name: "Divyang Shah",
      position: "Chairman",
      role: "Board of Governors",
      image: divyangImage,
      email: "rajesh.jain@jbf.org",
      phone: "+91 98765 43210",
      bio: "With over 25 years of experience in educational administration and governance, Dr. Rajesh leads the strategic vision of JBF.",
    },
    {
      name: "Deepak Bheda",
      position: "Vice Chairperson",
      role: "National Academic & Welfare Committee",
      image: priyaImage,
      email: "priya.sharma@jbf.org",
      phone: "+91 98765 43211",
      bio: "A distinguished educationist and social welfare advocate with expertise in student development and academic excellence.",
    },
    {
      name: "Girish Shah",
      position: "Secretary",
      role: "Finance & Fundraising Committee",
      image: girishImage,
      email: "vikram.mehta@jbf.org",
      phone: "+91 98765 43212",
      bio: "Financial strategist and chartered accountant with extensive experience in non-profit financial management and fundraising.",
    },
    {
      name: "Bipin Doshi",
      position: "Director",
      role: "Infrastructure & Safety Committee",
      image: bipinImage,
      email: "anita.doshi@jbf.org",
      phone: "+91 98765 43213",
      bio: "Infrastructure development expert with a focus on safety standards and modern hostel facility management.",
    },
    {
      name: "Nilesh Gandhi",
      position: "Advisor",
      role: "Technology & Innovation Committee",
      image: nileshImage,
      email: "arun.shah@jbf.org",
      phone: "+91 98765 43214",
      bio: "Technology innovator and digital transformation specialist driving JBF's digital platform development.",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#7A1E1E] to-[#8B2E2E] py-20 lg:py-32">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-[#D4A017] blur-3xl" />
          <div className="absolute bottom-0 left-0 h-96 w-96 rounded-full bg-[#D4A017] blur-3xl" />
        </div>

        <div className="relative z-10 mx-auto max-w-[1400px] px-4 text-white sm:px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <div className="mb-6 inline-block rounded-full border border-[#D4A017]/30 bg-[#D4A017]/20 px-4 py-2 text-sm text-[#D4A017] backdrop-blur-sm">
              Leadership Team
            </div>
            <h1 className="mb-6 text-5xl lg:text-6xl">Committee Members</h1>
            <p className="text-2xl leading-relaxed text-gray-100">
              Meet the dedicated leaders steering JBF towards excellence in
              hostel governance and student welfare.
            </p>
          </div>
        </div>
      </section>

      {/* Committee Members Section */}
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {committeeMembers.map(member => (
              <div
                key={member.name}
                className="group overflow-hidden rounded-xl border border-[#D4A017]/20 bg-[#FFF9F0] shadow-md transition-all hover:shadow-lg"
              >
                {/* Image */}
                <div className="relative overflow-hidden bg-white">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="h-80 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute bottom-3 left-3 right-3">
                    <div className="mb-1 inline-block rounded-full border border-white/20 bg-[#D4A017] px-3 py-1 text-[10px] font-medium text-white backdrop-blur-md">
                      {member.role}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4">
                  <h2 className="text-xl font-semibold text-[#7A1E1E]">
                    {member.name}
                  </h2>
                  <p className="text-sm font-medium text-gray-600">
                    {member.position}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-b from-white to-[#FFF5E6] py-20">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="mb-6 text-4xl font-bold text-[#7A1E1E]">
            Want to Join Our Team?
          </h2>
          <p className="mb-10 text-xl text-gray-600">
            We&apos;re always looking for passionate individuals to contribute
            to our mission of transforming student welfare.
          </p>
          <button
            className="transform rounded-xl bg-gradient-to-r from-[#7A1E1E] to-[#8B2E2E] px-10 py-4 text-white transition-all hover:-translate-y-1 hover:shadow-xl"
            onClick={() => {
              navigate("/contact");
            }}
          >
            Contact Us
          </button>
        </div>
      </section>
    </div>
  );
}
